<template>
  <v-container
    class="pa-0 mt-md-2"
  >
    <v-row no-gutters>
      <v-col
        cols="12"
        md="10"
        lg="8"
        offset-md="1"
        offset-lg="2"
      >
        <v-card
          flat
          tile
          class="pa-3"
        >
          <v-toolbar
            flat
          >
            <v-btn
              icon
              to="/eleave/list"
            >
              <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ $t('eLeave.ApproveAbsence') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-form ref="faltasForm">
            <v-row dense>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.approver"
                  :label="$t('eLeave.Sender')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.name"
                  :label="$t('TrainingClient.Identity.name')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.position"
                  :label="$t('Subsidy.CategoryOrCareer')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.department"
                  :label="$t('Subsidy.Subunit')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>

            <v-select
              v-model="form.absentTypeId"
              :item-text="$chPtField('chinDesc')"
              item-value="id"
              :items="customAbsenceTypes"
              :label="$t('eLeave.AbsenceReason')"
            />

            <!-- id=0 其他原因 -->
            <v-text-field
              v-if="form.absentTypeId === 0"
              v-model="form.otherReason"
              :label="$t('eLeave.PleasePointOut')"
            />

            <!-- id=26 公開考試 -->
            <template v-if="form.absentTypeId === 26">
              <div
                class="d-flex align-center"
              >
                <span
                  class="mr-2"
                  style="white-space: nowrap;"
                >
                  {{ $t('eLeave.TimeBetween') }}
                </span>
                <s-time-picker v-model="form.examTimeFrom" />
                <span
                  class="mx-2"
                  style="white-space: nowrap;"
                >
                  {{ $t('Text.To') }}
                </span>
                <s-time-picker v-model="form.examTimeTo" />
              </div>
            </template>

            <!-- id=13  喪事（請指出與死者關係） -->
            <template v-if="form.absentTypeId === 13">
              <v-row dense>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="relativeTypeId"
                    :item-text="$chPtField('chinDesc')"
                    item-value="id"
                    :items="relativeTypes"
                    :label="$t('eLeave.Relation')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.relationshipRemark"
                    :label="$t('PublicServant.Obser')"
                  />
                </v-col>
              </v-row>
            </template>

            <!-- id=24 考試科目 -->
            <v-text-field
              v-if="form.absentTypeId === 24"
              v-model="form.examSubjectContent"
              :label="$t('eLeave.PleasePointOut')"
            />

            <!-- id=27 履行法定義務(請指出) -->
            <v-text-field
              v-if="form.absentTypeId === 27"
              v-model="form.obrigacoesLegaisContent"
              :label="$t('eLeave.PleasePointOut')"
            />

            <v-row dense>
              <v-col
                cols="4"
                md="5"
              >
                <s-date-picker
                  v-model="form.startDate1"
                  show-leave
                  :label="$t('eLeave.StartDate')"
                  :rules="rules.requiredField"
                />
              </v-col>

              <v-col
                cols="4"
                md="5"
              >
                <s-date-picker
                  v-model="form.endDate1"
                  show-leave
                  :label="$t('eLeave.EndDate')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="4"
                md="2"
              >
                <v-text-field
                  v-model="form.numDays1"
                  :label="$t('eLeave.ALDays')"
                  readonly
                />
              </v-col>
            </v-row>

            <v-alert
              v-if="noticeMsg"
              dense
              outlined
              type="info"
              color="deep-orange"
            >
              {{ noticeMsg }}
            </v-alert>

            <br>
            <p class="grey--text text--darken-3">
              {{ $t('eLeave.ContactClaim') }}
            </p>
            <v-checkbox
              v-model="checkedStay"
              :label="$t('eLeave.StayMacau')"
              hide-details
            />
            <v-scroll-y-transition>
              <v-textarea
                v-show="checkedStay"
                v-model="form.memoStay"
                rows="2"
                hide-details
              />
            </v-scroll-y-transition>
            <v-checkbox
              v-model="checkedLeave"
              :label="$t('eLeave.LeaveMacau')"
              hide-details
            />
            <v-scroll-y-transition>
              <v-textarea
                v-show="checkedLeave"
                v-model="form.memoLeave"
                rows="2"
                hide-details
              />
            </v-scroll-y-transition>
            <br>
            {{ $t('Outbox.Attachment') }}
            <s-file-uploader-with-entity
              ref="attachUploader"
              multiple
              :post-url="uploadFileUrl"
              extensions="pdf,doc,docx,png,jpg,jpeg"
              accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
              :response.sync="attachResponse"
              :label="$t('Outbox.UploadAttachment')"
              @uploadError="onUploadError"
            />
            <br>
            <v-row>
              <v-col
                cols="12"
                md="8"
              >
                <s-search-staff
                  :select.sync="form.assignedToEuid"
                  :staff.sync="toStaffObj"
                  show-group
                  :label="$t('Training.SubmitTarget')"
                />
              </v-col>
            </v-row>

            <br>

            <v-btn
              :loading="loading"
              color="primary"
              class="mr-2"
              @click="showingConfirmDialog = true"
            >
              {{ $t('Text.Submit') }}
            </v-btn>

            <s-confirm-dialog
              v-model="showingConfirmDialog"
              :message="$t('eLeave.SubmitConfirmation')"
              :true-label="$t('ConfirmModal.OK')"
              :false-label="$t('Text.Cancel')"
              @confirm="submit"
            />

            <br><br>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import SSearchStaff from '@/components/SSearchStaff'
import SDatePicker from '@/components/SDatePicker'
import STimePicker from '@/components/STimePicker'
import SConfirmDialog from '@/components/SConfirmDialog'
import SFileUploaderWithEntity from '@/components/SFileUploaderWithEntity'
import { staffModule, eLeaveModule, codeTableModule, globalModule } from '../../store/moduleName'
import { mapState } from 'vuex'
import store from '../../store'
import eLeave from '../../store/modules/leave/eLeave'
import eLeaveApi from '../../api/leave/eLeave'
import { ID_SIGN_COMPLETE_CB_URL, ABSENT_TYPE, LOADING_TIMEOUT, BUSINESS_CODE } from '../../constant/constant'
import signHelper from '../../helper/signHelper'
import VuetifyJetValidator from 'vuetify-jet-validator'
import { mdiArrowLeft } from '@mdi/js'
import { eLeaveMethod } from '@/views/Eleave/mixins/eLeaveMethod'
import { uploadMethod } from '@/mixins/uploadMethod'

if (!store.state[eLeaveModule]) store.registerModule(eLeaveModule, eLeave)

export default {
  components: {
    SSearchStaff,
    SDatePicker,
    STimePicker,
    SConfirmDialog,
    SFileUploaderWithEntity
  },
  mixins: [eLeaveMethod, uploadMethod],
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      mdiArrowLeft: mdiArrowLeft,
      form: {
        absentTypeId: null,
        approver: this.$t('Subsidy.DirectorOrSubdirector'),
        assignedToEuid: null,
        assignedToGroupId: null,
        callbackUrl: null,
        department: null,
        name: null,
        position: null,
        startDate1: null,
        endDate1: null,
        examSubjectContent: null, // 考試科目  (參加期末考試) - 請指出科目
        // examTimeFromHour: null,
        // examTimeFromMinute: null,
        // examTimeToHour: null,
        // examTimeToMinute: null,
        memoLeave: null,
        memoStay: null,
        numDays1: null,
        obrigacoesLegaisContent: null, // 屐行法定義務 - 請指出
        otherReason: null, // 其他原因（請指出）
        relationshipContent: null, // 用戶選擇關係之 chinDesc / portDesc
        relationshipRemark: null,
        // relativeTypeId: null,
        relativeType: {},
        examTimeFrom: null,
        examTimeTo: null,
        attachments: []
      },
      loading: false,
      showingConfirmDialog: false,
      checkedLeave: false,
      checkedStay: false,
      toStaffObj: null,
      uploadFileUrl: eLeaveApi.uploadFileUrl + BUSINESS_CODE.ELEAVE_FALTA,
      attachResponse: [],
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      }
      // relationshipRemark: null
    }
  },
  computed: {
    ...mapState({
      staff: state => state[staffModule].info,
      appraiser: state => state[staffModule].appraiser,
      faltasForm: state => state[eLeaveModule].faltasForm,
      absenceTypes: state => state[eLeaveModule].faltasAbsenceTypes,
      customAbsenceTypes: state => state[eLeaveModule].customAbsenceTypes,
      relativeTypes: state => state[codeTableModule].relativeTypes
    }),

    noticeMsg: function () {
      if (this.form.absentTypeId === null) return null
      let absencetype = this.absenceTypes.find(type => type.id === this.form.absentTypeId)
      if (this.form.absentTypeId != null && this.form.startDate1 && this.form.endDate1) {
        this.getNumDays(this.form.startDate1, this.form.endDate1, this.form.absentTypeId)
      }
      return this.$chPtObjData('chinPromptMessage', absencetype)
    },
    relativeTypeId: {
      get () {
        return null
      },
      set (value) {
        if (this.form.absentTypeId === ABSENT_TYPE.DEAD_FIRST_SECOND_ID) {
          let type = this.relativeTypes.find(t => t.id === value)
          this.relationshipContent = this.$chPtObjData('chinDesc', type)
          this.form.relationshipContent = this.$chPtObjData('chinDesc', type)
          this.form.relativeType = type
          console.log(JSON.stringify(type))
          // this.form.absentTypeId = type.absentTypeId
        }
      }
    }

  },
  watch: {
    'form.startDate1': function (val) {
      if (!this.form.endDate1 || this.form.endDate1 < val) {
        this.form.endDate1 = val
      }
    }
  //   relationshipRemark (value) {
  //     if (value) {
  //       this.form.relationshipContent += ' (' + value + ')'
  //     } else {
  //       this.form.relationshipContent = this.form.relationshipContent.substring(0, this.form.relationshipContent.indexOf(' ('))
  //     }
  //     this.form.relationshipRemark = value
  //     return ''
  //   }
  },
  async created () {
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    if (!this.$store.state[codeTableModule].pubHolidays || !this.$store.state[codeTableModule].pubHolidays.length) {
      await this.$store.dispatch(codeTableModule + '/getPubHolidays')
    }
    this.$store.dispatch(eLeaveModule + '/getFaltasAbsenceTypes')
    this.$store.dispatch(codeTableModule + '/getRelativeTypes')
    this.form.name = this.$chPtObjData('chinName', this.staff)
    if (this.staff.officialTypeChinTitle) {
      this.form.position = this.$chPtObjData('officialTypeChinTitle', this.staff)
    } else {
      this.form.position = this.$chPtObjData('careerChinDesc', this.staff)
    }
    this.form.department = this.$chPtObjData('subunitChinName', this.staff)
    //    this.form.assignedToEuid = this.staff.defaultNextEuid
    this.form.assignedToEuid = this.appraiser.euid
    this.setApproverByLastFormMetas(this.form, BUSINESS_CODE.ELEAVE_FALTA)
  },
  methods: {
    submit () {
      // let tempRelContent = ''
      this.loading = true
      this.form.attachments = []
      if (!this.$refs.faltasForm.validate()) {
        this.loading = false
        return false
      }
      if (this.toStaffObj && this.toStaffObj.definedGroupId) {
        this.form.assignedToEuid = null
        this.form.assignedToGroupId = this.toStaffObj.definedGroupId
      }
      if (!this.form.assignedToEuid && !this.form.assignedToGroupId) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('TrainingClient.ChooseSubmitTarget'))
        this.loading = false
        return false
      }
      if (this.relationshipContent) {
        this.form.relationshipContent = this.relationshipContent
        if (this.form.relationshipRemark) {
          this.form.relationshipContent += ' (' + this.form.relationshipRemark + ')'
        }
      }
      if (this.attachResponse && this.attachResponse.length) {
        for (const a of this.attachResponse) {
          this.form.attachments.push(a.response)
        }
      }
      // console.log('attachResponse: ' + JSON.stringify(this.form.attachments))

      this.form.callbackUrl = ID_SIGN_COMPLETE_CB_URL
      this.$store.dispatch(eLeaveModule + '/assignFaltasForm', this.form)
      let finalForm = JSON.stringify(this.faltasForm)
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = eLeaveApi.faltasGetSignLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = eLeaveApi.faltasSignAndStartWorkflowUrl
      signObj[signHelper.REDIRECT_PATH] = '/eleave/list'
      signObj[signHelper.POST_FORM] = finalForm
      signObj[signHelper.SUCCESS_MSG_KEY] = 'TrainingClient.SaveSuccess'
      signObj[signHelper.FAIL_MSG_KEY] = 'Subsidy.AppForm.FailMessage'

      signHelper.signAndStartWorkflow(signObj)

      setTimeout(() => {
        this.loading = false
      }, LOADING_TIMEOUT)
    },

    getNumDays (sDate, eDate, absentTypeId) {
      eLeaveApi.getStaffAbsentWorkingDays(sDate, eDate, absentTypeId, cb => {
        this.form.numDays1 = cb
      })
    }
    // clearFile () {
    //   this.$refs.attachUploader.clearFile()
    // }
  }
}
</script>
